import {axios} from '@/services/axios'

export const getAssignedPlans = async (companyId) => {
  const res = await axios.get(`/Company/${companyId}/Plans/Assigned`);
  return res.data;
}